// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './AddedCodes.scss'
import closeIcon from '../../../../images/common/close-small.png'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const AddedCodes = ({ code, deleteCode }) => (
  <div className='added-code-container'>
    <label htmlFor='null' className='added-code-text'>
      {code.Code}
    </label>
    <img
      src={closeIcon}
      className='added-code-close-icon'
      role='presentation'
      alt='Remove code'
      onClick={() => {
        deleteCode(code)
      }}
    />
  </div>
)
